import { FunctionComponent } from 'preact';

type Props = {
  ageLimit: number | null;
};

export const AgeLimitLabel: FunctionComponent<Props> = ({ ageLimit }) => {
  if (ageLimit === null) {
    return null;
  }

  const label = ageLimit === 0 ? 'A' : ageLimit;

  return <span className="vgp-age-limit">{label}</span>;
};
